import {
	isOnboardingStatus,
	OnboardingStatus,
	OnboardingStatusResponse,
} from '@/entities/onboarding-status';
import { http } from '@/http';

// Dev-only stand-in for GET /v2/onboarding/{ulid}/status until the backend is
// deployed: set VITE_MOCK_ONBOARDING_STATUS to a JSON object with any of the
// response fields (or just a step name, e.g. PAYMENT) in .env.localhost.local.
function getMockedStatus(ulid: string): OnboardingStatus | null {
	const mock: string | undefined = import.meta.env.DEV
		? import.meta.env.VITE_MOCK_ONBOARDING_STATUS
		: undefined;
	if (!mock) {
		return null;
	}

	const overrides: Partial<OnboardingStatus> = mock.trim().startsWith('{')
		? JSON.parse(mock)
		: { step: mock.trim() };

	return {
		onboarding_ulid: ulid,
		step: 'FORM',
		payment_required: true,
		payment_status: overrides.step === 'KYC' ? 'PAID' : 'NONE',
		checkout_id: null,
		checkout_url: null,
		product_id: null,
		has_active_certificate: false,
		process_status: null,
		process: null,
		...overrides,
	};
}

export async function getOnboardingStatus(
	ulid: string,
): Promise<OnboardingStatus> {
	const mocked = getMockedStatus(ulid);
	if (mocked) {
		return mocked;
	}

	const status = await http.get<OnboardingStatusResponse>(
		`v2/onboarding/${encodeURIComponent(ulid)}/status`,
	);
	if (isOnboardingStatus(status)) {
		return {
			...status,
			checkout_id: status.checkout_id ?? null,
			checkout_url: status.checkout_url ?? null,
			product_id: status.product_id ?? null,
			process_status: status.process_status ?? null,
			process: status.process ?? null,
		};
	}
	throw new TypeError('Invalid onboarding status response');
}
